import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * Shared hook to detect mobile viewport
 * Uses 768px as the breakpoint (matches CSS media queries)
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

/**
 * Non-hook version for use in non-component contexts
 */
export function checkIsMobile(): boolean {
  return typeof window !== 'undefined' ? window.innerWidth <= MOBILE_BREAKPOINT : false;
}
